// The whole page, in the order of the sale: the timeline of one film, the
// zoom into one sentence of it, the hours, the films, the project you get,
// the one-minute film, the deal, the ask.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SiteNav, scrollToHash } from './sections/nav';
import { HeroTimeline } from './sections/timeline-hero';
import { Deal, Hours, ZoomSentence } from './sections/story';
import { CaseFilm, Films, Project } from './sections/proof';
import { AccentCTA } from './sections/sell';
import { SiteFooter } from './sections/closing';
import { FinalCTA } from './sections/final-lantern';

export function App() {
  // a link like /#contact (from the footer or the 404 page) lands on its section
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = window.setTimeout(() => scrollToHash(hash), 60);
    return () => window.clearTimeout(t);
  }, [hash]);

  // scroll-reveal: every section fades up on first view
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const els = [...document.querySelectorAll('section')];
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('crw-in'); io.unobserve(e.target); } });
    }, { threshold: 0.08 });
    els.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) { el.classList.add('crw-in'); }
      el.classList.add('crw-reveal');
      io.observe(el);
    });
    return () => io.disconnect();
  }, []);

  return (
    <div id="top">
      <SiteNav />
      {/* single <main> landmark: screen-reader navigation */}
      <main>
        <HeroTimeline />
        <ZoomSentence />
        <Hours />
        <Films />
        <Project />
        <CaseFilm />
        <Deal />
        {/* the one full-bleed colour surface: the first-film offer */}
        <AccentCTA />
        <FinalCTA />
      </main>
      <SiteFooter />
    </div>
  );
}
